import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=589332ea&scoped=true"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=589332ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589332ea",
  null
  
)

export default component.exports